<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Basic data')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormDropdown fieldName="worker_id"
                                  label="Worker"
                                  size="4"
                                  showClear
                                  :isFormDisabled="isFormDisabled"
                                  :filtering="true"
                                  :filter="(event) => onFilter(event, 'workers')"
                                  :options="select?.workers"
                                  v-model:field="crud.worker_id" />

                    <FormCalendar fieldName="assessment_from"
                                  label="From day"
                                  size="4"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.assessment_from" />

                    <FormCalendar fieldName="assessment_to"
                                  label="To day"
                                  size="4"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.assessment_to" />

                    <FormInputToggleButton fieldName="is_active"
                                           label="Is record active?"
                                           size="4"
                                           :default="true"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.is_active" />

                    <FormEditor fieldName="description"
                                label="Description"
                                :editorStyle="{ height: '120px' }"
                                :isFormDisabled="isFormDisabled"
                                v-model:field="crud.description" />
                </div>
            </TabPanel>

            <TabPanel :header="__('Changelog')"
                      headerClass="form-tab-header">
                <ChangeLog :log="crud?.log" />
            </TabPanel>
        </TabView>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { validation, onFilterService, initForm } from "@pages/Helper/crud_utils.js";
import FormDropdown from "@crud/FormDropdown.vue";
import FormMultiselect from "@crud/FormMultiselect.vue";
import FormCalendar from "@crud/FormCalendar.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";
import FormEditor from "@crud/FormEditor.vue";
import FormButtons from "@crud/FormButtons.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import { __, deepCopy } from "@helper/utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);
const autoSave = ref(false);

const options = ["workers"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
});

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading);
};

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
